// extracted by mini-css-extract-plugin
module.exports = {"languageSelector":"languageSelector__q+1Dt","selectButton":"selectButton__zEoSR","dropDown":"dropDown__636LP","superAdminAccess":"superAdminAccess__0sbRw"};